import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import Box from "ds/components/Box";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import Tag from "ds/components/Tag";

type StatusCheckAppEventsDrawerProps = {
  items: string[];
};

const StatusCheckAppEventsDrawer = createDrawer(({ items }: StatusCheckAppEventsDrawerProps) => {
  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="App events" />
        <DrawerCloseIcon />
      </DrawerHeader>

      <DrawerBody>
        <Box direction="column" gap="medium" align="start">
          {items.map((item, index) => (
            <Tag key={index} tag={item} />
          ))}
        </Box>
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showStatusCheckAppEventsDrawer = createDrawerTrigger(StatusCheckAppEventsDrawer);
